import React, { useState } from 'react';
import { FaFolder, FaFileAudio, FaEllipsisV, FaCloudUploadAlt } from 'react-icons/fa';

const ExplorerGrid = ({ view, folders, files, onFolderClick, onEdit, isUploading }) => {
  
  if (view === 'root') {
    return (
      <div className="grid grid-cols-2 md:grid-cols-4 lg:grid-cols-6 gap-6 p-2">
        {folders.map(folder => (
          <div 
            key={folder.id} 
            onClick={() => onFolderClick(folder)}
            className="group relative bg-white p-5 rounded-3xl border border-slate-100 hover:border-purple-400 hover:shadow-2xl hover:-translate-y-1 transition-all cursor-pointer text-center"
          >
            {/* Options Trigger */}
            <button 
              onClick={(e) => { e.stopPropagation(); onEdit(folder); }}
              className="absolute top-3 right-3 p-2 bg-slate-50 rounded-full opacity-0 group-hover:opacity-100 transition-opacity hover:bg-purple-50"
            >
              <FaEllipsisV className="text-slate-400 text-[10px]" />
            </button>

            {/* Folder / Artwork Icon */}
            <div className="w-20 h-20 mx-auto mb-4 flex items-center justify-center bg-purple-50 rounded-3xl overflow-hidden shadow-inner">
               {folder.artworkURL ? (
                 <img src={folder.artworkURL} className="w-full h-full object-cover" alt="art" />
               ) : (
                 <FaFolder className="text-purple-300 text-4xl" />
               )}
            </div>

            <h4 className="text-xs font-black text-slate-800 truncate px-2">{folder.programName}</h4>
            <p className="text-[9px] font-black text-purple-500 uppercase tracking-tighter mt-1 opacity-60">
              {folder.startTime?.toDate().toLocaleDateString('en-AU', { weekday: 'short', day: 'numeric', month: 'short' })}
            </p>
          </div>
        ))}
      </div>
    );
  }

  // FOLDER VIEW: Alphanumeric Files
  return (
    <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-3 p-2">
      {files.map((file, index) => (
        <div 
          key={file.name} 
          className="flex items-center gap-4 bg-white p-4 rounded-2xl border border-slate-100 hover:shadow-md transition-shadow group"
        >
          <div className="w-10 h-10 bg-blue-50 flex items-center justify-center rounded-xl flex-shrink-0">
             <span className="text-[10px] font-black text-blue-400">{index + 1}</span>
          </div>
          <div className="flex-grow min-w-0">
            <p className="text-xs font-bold text-slate-700 truncate">{file.name}</p>
            <p className="text-[10px] text-slate-400 uppercase font-black tracking-widest">Alphanumeric Part {index + 1}</p>
          </div>
          <FaFileAudio className="text-slate-200 group-hover:text-blue-400 transition-colors" />
        </div>
      ))}

      {files.length === 0 && !isUploading && (
        <div className="col-span-full py-20 text-center">
          <div className="bg-slate-100 w-16 h-16 rounded-full flex items-center justify-center mx-auto mb-4">
            <FaCloudUploadAlt className="text-slate-300 text-2xl" />
          </div>
          <p className="text-slate-400 font-bold text-sm italic">This program folder is empty.</p>
          <p className="text-[10px] text-slate-300 font-black uppercase mt-1">Drag files here to sync with storage</p>
        </div>
      )}
    </div>
  );
};

export default ExplorerGrid;